export default "__VITE_ASSET__97FjSo0e__"